// Runtime environment config accessor.
//
// Values are provided at runtime by /env.js (window.__ENV__), which is loaded
// before the app bundle and can be remounted per-environment (k8s ConfigMap /
// volume) without rebuilding the image. Build-time import.meta.env vars remain
// the fallback for local development.
//
// Mirrors sybil-fe's 0.runtime-env.client plugin: only non-empty values from
// window.__ENV__ override the fallbacks, so a key left blank in env.js keeps
// the build-time default.

interface RuntimeEnv {
  apiBase?: string
}

const runtimeEnv: RuntimeEnv =
  (typeof window !== 'undefined' && window.__ENV__) || {}

function pick(runtimeValue: string | undefined, fallback: string): string {
  return runtimeValue && runtimeValue !== '' ? runtimeValue : fallback
}

export const API_BASE = pick(
  runtimeEnv.apiBase,
  import.meta.env.VITE_SYBIL_API_URL || 'http://127.0.0.1:8000'
)
